import React, { createContext, useContext } from 'react';
import {
  FIREBASE_CONFIG,
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_MAP_ID,
  RECAPTCHA_SITE_KEY,
} from '../config/apiKeys.js';

const ApiKeysContext = createContext();

export const useApiKeys = () => {
  const context = useContext(ApiKeysContext);
  if (!context) {
    throw new Error('useApiKeys must be used within an ApiKeysProvider');
  }
  return context;
};

const contextValue = {
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  googleMapsMapId: GOOGLE_MAPS_MAP_ID,
  recaptchaSiteKey: RECAPTCHA_SITE_KEY,
  firebaseConfig: FIREBASE_CONFIG,
  isLoading: false,
  error: null,
  isReady: true,
};

export const ApiKeysProvider = ({ children }) => (
  <ApiKeysContext.Provider value={contextValue}>
    {children}
  </ApiKeysContext.Provider>
);
